module.exports = "<p>\r\n  about-us works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/about-us/about-us.component.html
// module id = ../../../../../src/app/components/about-us/about-us.component.html
// module chunks = 0